import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const MicroPage = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M17.579 17.603v3.456h6.539v-11.901h-13.077v5.263h5.221l-2.541 2.632h-6.141v7.368h8.421v-5.183l1.579-1.635zM9.158 14.421v-7.421c0-0.552 0.448-1 1-1h14.842c0.552 0 1 0.448 1 1v14.842c0 0.552-0.448 1-1 1h-7.421v2.658c0 0.276-0.224 0.5-0.5 0.5h-10.579c-0.276 0-0.5-0.224-0.5-0.5v-10.579c0-0.276 0.224-0.5 0.5-0.5h2.658zM12 19.954l7.605-7.875c0.323-0.335 0.856-0.344 1.191-0.021s0.344 0.856 0.021 1.191l-7.605 7.875c-0.323 0.335-0.856 0.344-1.191 0.021s-0.344-0.856-0.021-1.191z" />
  </SvgIcon>
);

export default MicroPage;
